<template>

    <div class="personal-section__item">
        <div class="personal-card card">

            <div class="personal-card__body" v-if="declarer.DeclarerType == 1">
                <div class="personal-card__head">
                    <div class="personal-card__title _entity h3">
                        Наименование Заявителя:
                        <span> {{declarer.Name}}</span>
                    </div>
                    <div class="personal-card__remove">
                        <button href="" class="button-icon button-icon--th-slider" v-on:click="confirmDelete = true">
                            <i class="icon icon--remove">
                            </i>
                        </button>
                        <modalDeleteDeclarer v-if="confirmDelete" :declarer="declarer" @close="confirmDelete = false"></modalDeleteDeclarer>
                    </div>
                </div>
                <div class="personal-card__caption">
                    <div class="personal-card__item">
                        <span>ИНН: </span>
                        {{declarer.INN}}
                    </div>
                    <div class="personal-card__item">
                        <span>Тип заявителя:</span>
                        Юридическое лицо
                    </div>
                    <div class="personal-card__item">
                        <span>Доверенность (срок действия):</span>
                        {{declarer.AttorneyDate}}
                    </div>
                </div>
            </div>

            <div class="personal-card__body" v-if="declarer.DeclarerType == 2">
                <div class="personal-card__head">
                    <div class="personal-card__title _entity h3">
                        Наименование Заявителя:
                        <span> {{declarer.FIO}}</span>
                    </div>
                    <div class="personal-card__remove">
                        <button href="" class="button-icon button-icon--th-slider" v-on:click="confirmDelete = true">
                            <i class="icon icon--remove">
                            </i>
                        </button>
                        <modalDeleteDeclarer v-if="confirmDelete" :declarer="declarer" @close="confirmDelete = false"></modalDeleteDeclarer>
                    </div>
                </div>
                <div class="personal-card__caption">
                    <div class="personal-card__item">
                        <span>СНИЛС: </span>
                        {{declarer.SNILS}}
                    </div>
                    <div class="personal-card__item">
                        <span>Тип заявителя:</span>
                        Физическое лицо
                    </div>
                    <div class="personal-card__item">
                        <span v-if="declarer.isRepresentative">По доверенности</span>
                        <span v-else="declarer.isRepresentative">Лично</span>
                    </div>
                    <div class="personal-card__item" v-if="declarer.isRepresentative">
                        <span>Доверенность (срок действия):</span>
                        {{declarer.AttorneyDate}}
                    </div>
                </div>
            </div>

            <div class="personal-card__body" v-if="declarer.DeclarerType == 3">
                <div class="personal-card__head">
                    <div class="personal-card__title _entity h3">
                        Наименование Заявителя:
                        <span> {{declarer.FIO}}</span>
                    </div>
                    <div class="personal-card__remove">
                        <button href="" class="button-icon button-icon--th-slider" v-on:click="confirmDelete = true">
                            <i class="icon icon--remove">
                            </i>
                        </button>
                        <modalDeleteDeclarer v-if="confirmDelete" :declarer="declarer" @close="confirmDelete = false"></modalDeleteDeclarer>
                    </div>
                </div>
                <div class="personal-card__caption">
                    <div class="personal-card__item">
                        <span>Тип заявителя:</span>
                        Индивидуальный предприниматель
                    </div>
                    <div class="personal-card__item">
                        <span v-if="declarer.isRepresentative">По доверенности</span>
                        <span v-else="declarer.isRepresentative">Лично</span>
                    </div>
                    <div class="personal-card__item" v-if="declarer.isRepresentative">
                        <span>Доверенность (срок действия):</span>
                        {{declarer.AttorneyDate}}
                    </div>
                </div>
            </div>

            <div class="personal-card__body" v-if="declarer.DeclarerType == 4">
                <div class="personal-card__head">
                    <div class="personal-card__title _entity h3">
                        Наименование Заявителя:
                        <span> {{declarer.Name}}</span>
                    </div>
                    <div class="personal-card__remove">
                        <button href="" class="button-icon button-icon--th-slider" v-on:click="confirmDelete = true">
                            <i class="icon icon--remove">
                            </i>
                        </button>
                        <modalDeleteDeclarer v-if="confirmDelete" :declarer="declarer" @close="confirmDelete = false"></modalDeleteDeclarer>
                    </div>
                </div>
                <div class="personal-card__caption">
                    <div class="personal-card__item">
                        <span>Тип заявителя:</span>
                        ОМСУ
                    </div>
                </div>
            </div>

            <div class="personal-card__icon">
                <img src="/images/card-head-icons/entity.svg" alt="">
            </div>
        </div>
        <a :href="'#'" class="personal-section__ctrl link link--primary disabled" data-toggle="collapse">
            <span class="link__text">Управление рассылкой</span>
        </a>

        <!--<div :id="account.AccountId" class="personal-section__drop accordion-body collapse">
            <div class="personal-section__inner accordion-body__inner">
                <div class="settings">
                    <form action="">
                        <div class="settings__item head-card head-card--fill card">
                            <div class="head-card__body">
                                <div class="head-card__title h3">Настройки рассылки платежных документов:</div>
                                <div class="head-card__caption">Подпишитесь на получение счетов, Lorem ipsum – псевдо-латинский текст, который используется для веб дизайна, типографии, оборудования, и распечатки вместо английского</div>
                            </div>
                            <div class="head-card__icon">
                                <img src="/images/card-head-icons/docs.svg" alt="">
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Рассылка Электронного ЕПД на email</div>
                                    <div class="data-card__caption">
                                        Введите email чтобы получать рассылку платежей по электронной почте
                                    </div>
                                </div>
                                <div class="data-card__right data-card__right--revere">
                                    <label class="switch switch--right">
                                        <input class="switch__checkbox" data-toggle-switch="" :data-target="'#datacard_' + account.AccountId" type="checkbox">
                                        <div class="switch__label">
                                            <div class="switch__text">Нет</div>
                                            <div class="switch__text _last">Да</div>
                                        </div>
                                        <div class="switch__view"></div>
                                    </label>
                                </div>
                            </div>
                            <div :id="'datacard_' + account.AccountId" class="data-card__form data-card__form--sm accordion-body collapse">
                                <div class="data-card__inner accordion-body__inner">
                                    <div class="small-form">
                                        <div class="small-form__body">
                                            <div class="small-form__input">
                                                <label class="txt-input">
                                                    <div class="txt-input__label">Введите емайл для рассылки:</div>
                                                    <div class="txt-input__input">
                                                        <input class="txt-input__field input" type="text" placeholder="ivan2008@email.ru">
                                                        <div class="txt-input__sup">
                                                            <i class="icon icon--check"></i>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="small-form__submit">
                                                <button class="button button--th-second" type="submit">Подписаться</button>
                                            </div>
                                        </div>
                                        <div class="small-form__caption">Мы отправили сообщение вам на почту ivan2008@email.ru, следуйте инструкции для подтверждения</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Рассылка отчётных документов через ЭДО</div>
                                </div>
                                <div class="data-card__right">
                                    <a href="" class="button button--th-second">Подключить</a>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item head-card head-card--fill card">
                            <div class="head-card__body">
                                <div class="head-card__title h3">Настройки SMS и E-Mail рассылок:</div>
                                <div class="head-card__caption">Настройте удобный доступ к уведомлениям</div>
                            </div>
                            <div class="head-card__icon">
                                <img src="/images/card-head-icons/email.svg" alt="">
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о задолженности</div>
                                    <div class="data-card__caption">Даты рассылки 10-15 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о сроке передаче показаний</div>
                                    <div class="data-card__caption">Даты рассылки 20-25 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о задолженности</div>
                                    <div class="data-card__caption">Даты рассылки 20-25 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о сроке передаче показаний</div>
                                    <div class="data-card__caption">Даты рассылки 20-25 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__confirm card">
                            <div class="settings__caption">
                                Указанные изменения вступят в силу с 1 числа нового расчётного месяца.
                            </div>
                            <div class="settings__ctrl">
                                <a href="" class="button button--th-second">Сохранить</a>
                                <a :href="'#' + account.AccountId" class="button button--th-link" data-toggle="collapse">Отменить</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>-->
    </div>

</template>

<script>
	import modalDeleteDeclarer from './ModalDeleteDeclarer.vue'


    export default {
		components: {
			modalDeleteDeclarer
        },

        props: ['declarer'],

		data: function () {
			return {
                confirmDelete: false
			}
        },

        computed: {
            //cotractDate: function () {
            //    if (this.account.ContractDate) {
            //        return new Date(this.account.ContractDate).toLocaleDateString("ru-RU");
            //    } else {
            //        return '';
            //    }
            //},
            //contract: function () {
            //    return `${this.account.ContragentShortName} 
            //        ${!!this.account.ContractNumber ? '№ ' + this.account.ContractNumber : ''} 
            //        ${!!this.cotractDate ? 'от ' + this.cotractDate : ''} 
            //        ${!!this.account.Division.Caption ? 'с ' + this.account.Division.Caption : ''}`
            //}
        },

        methods: {
            //onRemoveComponent: function () {
            //    this.componentVisible = false;
            //}
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/Declarer.vue